export default __webpack_public_path__ + "static/media/checkbox-circle-line.5c94f9e7.svg";